import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    IStyleBomLine,
    IStyleBomLineCreateRequest,
    IStyleBomLineUpdateRequest,
} from '../interfaces/garments/styleBom.interface';

const headers = () => AuthService.getAuthHeader();

export const StyleBomService = {
    list: async (institutionId: string, styleId: string): Promise<IStyleBomLine[]> => {
        const res = await axios.get(ENDPOINTS.BOM_LINE.LIST(institutionId, styleId), { headers: headers() });
        return res.data;
    },

    create: async (institutionId: string, request: IStyleBomLineCreateRequest): Promise<IStyleBomLine> => {
        const res = await axios.post(ENDPOINTS.BOM_LINE.CREATE(institutionId), request, { headers: headers() });
        return res.data;
    },

    update: async (institutionId: string, id: string, request: IStyleBomLineUpdateRequest): Promise<IStyleBomLine> => {
        const res = await axios.put(ENDPOINTS.BOM_LINE.UPDATE(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.BOM_LINE.DELETE(institutionId, id), { headers: headers() });
    },
};

export default StyleBomService;
